import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  CustomResultOfPaginatedListOfGetOutBoxMessageResendHistoryByScheduledIdDto,
  GetEnumValuesDto,
  GetOutBoxMessageResendHistoryByScheduledIdDto,
  PaginatedListOfGetOutBoxMessageResendHistoryByScheduledIdDto,
} from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseIndexPageComponent } from '../../../shared/base/components/base-index-page.component';
import { OutBoxMessageResendHistoriesService } from './../../../../core/api/services';

@Component({
  selector: 'app-resend-detail',
  templateUrl: './resend-detail.component.html',
  styleUrls: ['./resend-detail.component.scss'],
  standalone: false,
})
export class ResendDetailComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties
  @Input('scheduledMessageId') input_scheduledMessageId: number;
  @Output('isClose') output_isClose = new EventEmitter<boolean>();

  pageName = 'outboxMessages.resendDetail';

  @Input()
  modelWithPagination$: Observable<PaginatedListOfGetOutBoxMessageResendHistoryByScheduledIdDto>;
  items$: Observable<Array<GetOutBoxMessageResendHistoryByScheduledIdDto>>;

  SendTypesEnumValues: GetEnumValuesDto[] = [];

  //#endregion

  constructor(protected currentService: OutBoxMessageResendHistoriesService) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit(true);
      this.pageConfig.loading = true;
      this.pageConfig.tableConfig.comparisonObjects = []; //clean stored search
      this.pageConfig.showDefaultBtns = false;
      this.pageConfig.tableConfig.showOperationColumn = false;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('DeliveryStatus')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SendTypesEnumValues = values));
  }

  configTableColumns() {
    this.tableVocabs = this.pageVocabs;

    this.tableColumns = [
      {
        title: `${this.tableVocabs}createdBy`,
        name: 'createdBy',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}scheduledMessageId`,
        name: 'scheduledMessageId',
        hasSearch: true,
        type: 'number',
      },
      {
        title: `${this.tableVocabs}newScheduledMessageId`,
        name: 'newScheduledMessageId',
        hasSearch: true,
        type: 'number',
      },
      {
        title: `${this.tableVocabs}deliveryStatuses`,
        name: 'deliveryStatuses',
        noSorting: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        type: 'dateTime',
        hasSearch: true,
      },
    ];
  }

  //#region Api

  //Get All
  getPaginationApi(): Observable<CustomResultOfPaginatedListOfGetOutBoxMessageResendHistoryByScheduledIdDto> {
    if (
      this.pageConfig.tableConfig.paginationModel.pageSize >
      this.pageConfig.tableConfig.paginationModel.totalCount
    )
      this.pageConfig.tableConfig.paginationModel.pageNumber = 1;
    return this.currentService.outBoxMessageResendHistoriesGetOutBoxMessageResendHistoryByScheduledId(
      {
        body: {
          ...this.getBaseModelWithPaginationParams(),
          scheduledMessageId: this.input_scheduledMessageId,
        },
      }
    );
  }

  onReset() {
    this.getTableData();
  }
  onClose() {
    this.output_isClose.emit(true);
  }
}
